import { useEffect, useState, Suspense } from 'react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { api_menu_list } from '../../states/selector'
import { BrowserRouter, Route, Switch, Link, NavLink, useParams, useHistory, useRouteMatch, useLocation, Redirect } from 'react-router-dom';
import { Grid, Box, Container, Typography, Pagination } from '@mui/material'
import Items from '../../blocks/items'
import { CONFIG } from '../../states/settings'


import AppBarHead from '../../common/appbarhead';

const MenuDetail = (props)=>{
  let [ menu_list, setMenuList ] = useRecoilState(api_menu_list)
  let [ selected_menu, setSelectedMenu ] = useState(null)

  let { id } = useParams(null)
  let { path, url } = useRouteMatch()
  let uh = useHistory()
  let ul = useLocation()

  useEffect(()=>{
    setMenuList(menu_list)
    
    let item = menu_list.find(v => v.group_name == id)
    setSelectedMenu(item)
  }, [id])

  return (
    <Box className='wrapper' sx={{
      '@media (max-width: 900px)':{
        padding: 2
      },
      padding: 3
    }}>
      {
        selected_menu
        ? (
          <>
            <Typography component="h3" variant="h4" mb='1.2rem' className='menu_name_underlayer' sx={{paddingBottom:'10px', fontWeight:700}}>
              <Link to={`${CONFIG.PAGE_ROOT_PATH}/${selected_menu.group_name}/`} className='link_sub'>
                { selected_menu.group_name }
              </Link>
            </Typography>

            <Items
              json_file={selected_menu.json_file}
              menu_id={id}
              use_pager={true}
              use_grid={false}
              show_full={true}
              from_url={ul.pathname}
            />
          </>
        )
        : (<></>)
      }
    </Box>
  )
}

export default MenuDetail;
